<template>
  <!-- 项目详情 - 成员列表 author: zhangxiaofeng -->
  <div class="project-members relative height-full">
    <div class="absolute width-full height-full">
      <h4 class="h4" v-if="(prjRole ===1 || isAdmin) && !isRecord">
        <w-button
          type="primary"
          @click="addMemberClick">
          <i class="r2-icon-content_add"></i>
          添加成员
        </w-button>
      </h4>
      <div class="ui-fixed tree-table fit flex flex-column table-medium table-beyond-hiding" style="height: calc(100% - 80px);" id="tree-table" v-loading="loading">
        <div class="header-wrapper" ref="headerWrapper">
          <div class="table-header flex flex-row" style="width: 100%;">
            <div class="header-item is-leaf flex-1">成员姓名</div>
            <div class="header-item is-leaf flex-1">成员账号</div>
            <template v-if="isRecord">
              <!--<div class="header-item is-leaf" style="width: 180px;">权限</div>-->
              <div class="header-item is-leaf" style="width: 120px;">添加时间</div>
            </template>
            <template v-else-if="prjRole!==1&&!isAdmin">
              <div class="header-item is-leaf" style="width: 180px;">项目角色</div>
              <div class="header-item is-leaf" style="width: 120px;">添加时间</div>
            </template>
            <template v-else>
              <div class="header-item is-leaf" style="width: 180px;">项目角色</div>
              <div class="header-item is-leaf" style="width: 120px;">添加时间</div>
              <div class="header-item is-leaf is-operate" style="width: 100px;">操作</div>
            </template>
            <div class="has-gutter" v-if="scrollY"></div>
          </div>
        </div>
        <div class="body-wrapper flex-1" style="overflow: auto;" ref="bodyWrapper">
          <ul class="container" style="width: 100%;" ref="containerWrapper">
            <li class="flex flex-row row row--level-1" v-for="(item, index) in data" :key="index">
              <div class="cell column_1 flex-1">
                <w-avatar :size="34" src="https://account.glodon.com/avatar/show/6565161893702091179/32" inline />
                <span class="inline-block ellipsis" style="line-height: 34px;" :title="item.userName">
                <i style="margin-left: 12px;">{{item.userName}}</i>
                <span v-if="item.recordUser" class="color-red">(备案人)</span>
                <w-tag v-if="+item.status > 0" style="color: rgba(33,37,48,0.55);border-color: rgba(222,223,224,1);"
                       class="margin-left-10" size="mini" around>
                  已删除
                </w-tag>
              </span>
              </div>
              <div class="cell column_2 flex-1">{{item.account}}</div>
              <div class="cell column_3" style="width: 180px;" v-if="!isRecord">
                <!--<div style="width: 100%;" v-if="isRecord">-->
                  <!--<i style=" width: 50px; display: inline-block;">{{item | privilegeFilter}}</i>-->
                  <!--<w-dropdown @command="handlerAction" v-if="(prjRole!==2 || isAdmin) && item.roleId !== 1 && item.userRole !== 2">-->
                    <!--<span class="over-choose-icon">-->
                      <!--<i class="r2-icon-nav_arrow_drop_down"></i>-->
                    <!--</span>-->
                    <!--<w-dropdown-menu slot="dropdown">-->
                      <!--<w-dropdown-item :disabled="item.roleId !== 3" :command="{item, value: 1, fn: 'privilegeClick', roleId: item.roleId}">-->
                        <!--<span :class="{'color-blue': item.roleId !== 3}">可见</span>-->
                      <!--</w-dropdown-item>-->
                      <!--<w-dropdown-item :disabled="item.roleId === 3" :command="{item, value: 2, fn: 'privilegeClick', roleId: item.roleId}">-->
                        <!--<span :class="{'color-blue': item.roleId === 3}">不可见</span>-->
                      <!--</w-dropdown-item>-->
                    <!--</w-dropdown-menu>-->
                  <!--</w-dropdown>-->
                <!--</div>-->
                <div style="width: 100%;">
                  <span style="display: inline-block;">{{item | roleFilter}}</span>
                  <w-dropdown v-if="(prjRole ===1 || isAdmin) && item.roleId !== 1 && item.userRole !== 2"
                              style="margin-left: 10px;" @command="handlerAction">
                    <span class="over-choose-icon">
                      <i class="r2-icon-nav_arrow_drop_down"></i>
                    </span>
                    <w-dropdown-menu slot="dropdown">
                      <w-dropdown-item :disabled="item.roleId === 1" :command="{item, value: 1, fn: 'handleClick', roleId: item.roleId}">
                        <span :class="{'color-blue': item.roleId === 1}">项目负责人</span>
                      </w-dropdown-item>
                      <w-dropdown-item :disabled="item.roleId !== 1" :command="{item, value: 2, fn: 'handleClick', roleId: item.roleId}">
                        <span :class="{'color-blue': item.roleId !== 1}">项目成员</span>
                      </w-dropdown-item>
                    </w-dropdown-menu>
                  </w-dropdown>
                </div>
              </div>
              <div class="cell column_4" style="width: 120px;">{{item.createTime | formatDate}}</div>
              <template v-if="isRecord"></template>
              <template v-else-if="prjRole!==1&&!isAdmin"></template>
              <div class="cell column_5 is-operate" style="width: 100px;" v-else>
                <div style="width: 100%;">
                  <i v-if="item.roleId==1" class="r2-icon-action_delete_outline not-allowd cursor-not-allowed"></i>
                  <el-tooltip content="删除" v-else>
                    <i @click="deleteOption(item)" class="r2-icon-action_delete_outline cursor-pointer"></i>
                  </el-tooltip>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <w-dialog
        v-if="!isRecord"
        title="添加成员"
        @close="$refs.addMember.close()"
        :show="show"
        :boxStyle="{width: '1058px', zIndex: 1009,padding: 0}"
        >
        <AddMember
          ref="addMember"
          :isAdmin="prjRole==1&&isAdmin"
          :AddMemberShow="show"
          :sellist="sellist"
          :MemberInfo="MemberInfo"
          v-on:closeMemberShow="closeMemberShow"
          v-on:sellListCallBack="sellListCallBack"
        ></AddMember>
        <div slot="footer">
          <w-button type="primary" @click.stop.prevent="$refs.addMember.confirm()">确定</w-button>
          <w-button type="minor" @click.stop.prevent="$refs.addMember.close()">取消</w-button>
        </div>
      </w-dialog>
      <verify-code  @dialogVisibleEvent='showVerify=false' :showVerify="showVerify" @verifyConfirm='verifyConfirm'></verify-code>
    </div>
  </div>
</template>
<style lang="less" type="text/less" scoped>
.project-members {
  box-sizing: border-box;
  margin: 0 24px;
  .h4 {
    font-size: 16px;
    font-weight: 500;
    color: rgba(33, 37, 48, 1);
    margin-bottom: 16px;
    height: 32px;
  }
}
.over-choose-icon {
  border-radius: 4px;
  border: 1px solid rgba(33, 37, 48, 0.55);
  line-height: 22px;
  &:hover {
    color: #2079fa;
    border-color: rgba(32, 121, 250, 1);
  }
}
.role-box {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 8px 0px rgba(33, 37, 48, 0.2);
  border-radius: 4px;
  padding: 4px 8px;
  .role-item {
    line-height: 32px;
    padding: 0 8px;
    &:hover {
      background: rgba(243, 244, 247, 1);
    }
  }
  .active-menu-item {
    color: #2079fa;
  }
}
.operation {
  color: rgba(33,37,48,0.55);;
  cursor: pointer;
  padding: 0 4px;
  &:hover {
    color: #2079fa;
  }
}
.not-allowd {
  color: #2125304f;
  &:hover {
    color: #2125304f;
  }
}
</style>
<script>
import r2Project from '@/assets/service/r2Project'
import { getCookie } from '@/assets/utils/CommonUtil'
import { formatDate } from '@/assets/utils/Date'
import VerifyCode from '@/components/VerifyCode'
import { zjycloud } from '@/assets/js/config'
import AddMember from '@/views/project/children/component/AddMember'
import LoginService from '@/assets/service/login'
import { mapGetters, mapActions } from 'vuex'
// let role

const columns1 = [
  {
    title: '成员姓名',
    dataIndex: 'userName',
    key: 'userName',
    scopedSlots: { customRender: 'userName' }
  },
  {
    title: '成员账号',
    dataIndex: 'account',
    key: 'account'
  },
  {
    title: '项目角色',
    dataIndex: 'roleId',
    key: 'roleId',
    scopedSlots: { customRender: 'roleId' }
  },
  {
    title: '添加时间',
    dataIndex: 'createTime',
    key: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  }
]
const columns2 = [
  {
    title: '成员姓名',
    dataIndex: 'userName',
    key: 'userName',
    scopedSlots: { customRender: 'userName' }
  },
  {
    title: '成员账号',
    dataIndex: 'account',
    key: 'account'
  },
  {
    title: '项目角色',
    dataIndex: 'roleId',
    key: 'roleId',
    scopedSlots: { customRender: 'roleId' }
  },
  {
    title: '添加时间',
    dataIndex: 'createTime',
    key: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
    width: '80px',
    align: 'center'
  }
]
// 备案人员列表
const columns3 = [
  {
    title: '成员姓名',
    dataIndex: 'userName',
    key: 'userName',
    scopedSlots: { customRender: 'userName' }
  },
  {
    title: '成员账号',
    dataIndex: 'account',
    key: 'account'
  },
  {
    title: '权限',
    dataIndex: 'roleId',
    key: 'roleId',
    scopedSlots: { customRender: 'roleId' }
  },
  {
    title: '添加时间',
    dataIndex: 'createTime',
    key: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  }
]
export default {
  name: 'ProjectMembers',
  data () {
    return {
      showVerify: false,
      scrollY: false,
      isRecord: /\/database\/data\/record\//.test(this.$route.path),
      isAdmin: false,
      data: [],
      columns1,
      columns2,
      columns3,
      show: false,
      tableHeight: '500px',
      styleObj: {
        background: '#eee'
      },
      reNamePrj: -1,
      oldName: '',
      canName: true,
      token: getCookie('ZJYTOKEN'),
      workspaceId: getCookie('enterpriseWorkspaceIdValue'),
      tableData: [],
      sellist: [],
      permiss: this.$route.query.permission,
      loading: false,
      dialogVisible: false,
      MemberInfo: {
        projectId: this.$route.params.id,
        MemberShow: false
      },
      headers: {
        Authorization: getCookie('opToken'),
        // "Content-type": "application/x-www-form-urlencoded"
        'Content-type': 'application/json'
      },
      user: {},
      pagination: {
        hideOnSinglePage: true
      }
    }
  },
  computed: {
    ...mapGetters(['prjRole']),
    hasMaster: function () {
      let hasMaster = false
      this.data.map(item => {
        if (+item.roleId === 1) {
          hasMaster = true
        }
      })
      return hasMaster
    }
  },
  watch: {
    prjRole: function (val) {
      // if (role !== '总负责人') {
      //   if (+val === 1) {
      //     role = '项目管理者'
      //   } else {
      //     role = '项目编辑者'
      //   }
      // }
    }
  },
  components: {
    AddMember,
    VerifyCode
  },
  methods: {
    ...mapActions({ fetchRole: 'project/fetchRole' }),
    // 下拉菜单指令事件
    handlerAction ({item, value, fn, roleId}) {
      this[fn](item, value, roleId)
    },
    // 1.1 初始化项目成员
    init () {
      let _this = this
      let api = 'getMembers'
      let param = {
        id: this.MemberInfo.projectId
      }
      if (this.isRecord) {
        api = 'getRecordedMembersList'
      }
      this.loading = true
      _this.canName = true
      r2Project[api](param)
        .then(ret => {
          this.loading = false
          if (+ret.code === 200) {
            let dataArr = ret.data
            let managerIndex
            for (let index = 0; index < dataArr.length; index++) {
              if (dataArr[index].userRole === 2) {
                managerIndex = index
                break
              }
            }
            if (managerIndex) {
              let manager = dataArr.splice(managerIndex, 1)
              dataArr.unshift(manager[0])
            }
            this.data = dataArr
          } else {
            this.loading = false
            this.$message({
              type: 'error',
              message: '失败了，请稍后重试！'
            })
          }
        })
        .catch(() => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '失败了，请稍后重试！'
          })
        })
    },
    // 1.2 更改权限
    handleClick (item, newRole, oldRole) {
      if (newRole === 1) {
        this.$confirm({
          message: `项目只能有一个成员拥有“项目负责人”项目角色，确定要将${item.userName}用户项目角色设置为“项目负责人”？`,
          width: 500,
          submit: () => {
            this.updateProjectRole(item, newRole, oldRole)
            this.sentLog(100112044)
          }
        })
      } else {
        this.updateProjectRole(item, newRole, oldRole)
      }
      this.sentLog(100112043)
    },
    // 变更项目角色事件
    updateProjectRole (item, newRole, oldRole) {
      let param = {
        id: this.MemberInfo.projectId,
        memberId: item.memberId,
        oldRole: oldRole,
        newRole: newRole,
        url: zjycloud + '/#/project/joined/list',
        force: true
      }
      item.visible = false
      this.loading = true
      r2Project.changeAuthor(param).then(ret => {
        this.loading = false
        if (+ret.code === 200) {
          this.init()
          this.fetchRole({ id: this.MemberInfo.projectId }).then(() => {})
        } else if (+ret.code === 240015 || +ret.code === 403){
          this.$message({
            type: 'error',
            message: '无访问权限！'
          })
        } else {
          this.$message({
            type: 'error',
            message: '失败了，请稍后重试！'
          })
        }
      }).catch(() => {
        this.loading = false
        this.$message({
          type: 'error',
          message: '失败了，请稍后重试！'
        })
      })
      // if (role !== '总负责人') {
      //   if (+this.prjRole === 1) {
      //     role = '项目管理者'
      //   } else {
      //     role = '项目编辑者'
      //   }
      // }
    },
    // 1.2.2 权限点击-取消
    cancelHandle (data) {
      data.visible = false
    },
    // 1.2.1 权限点击
    changeRoleHandle () {

    },
    // 1.3 添加成员
    sellListCallBack (sellist) {
      let rolesArray = []
      sellist.map(item => {
        rolesArray.push({
          memberId: item.memberId,
          roleId: item.role
        })
      })
      this.loading = true
      let url = zjycloud + '/#/project/joined/list'
      r2Project
        .addMembers(rolesArray, this.MemberInfo.projectId, encodeURIComponent(url))
        .then(ret => {
          this.loading = false
          if (+ret.code === 200) {
            // 添加项目员工
            this.init()
            this.fetchRole({ id: this.MemberInfo.projectId }).then(() => {})
            this.$message.success('添加成功!')
            if (sellist.length > 0) {
              this.addOperationRecords(13, sellist, {page: 'detailMember', action: 'addMember'})
            }
          } else if (+ret.code === 240015 || +ret.code === 403){
            this.$message.warning('无访问权限！')
          } else {
            this.$message.error('失败了，请稍后重试！')
          }
        })
        .catch(() => {
          this.loading = false
          this.$message.error('失败了，请稍后重试！')
        })
    },
    // // 判断是否已经二次验证
    // async isDoubleVerify (){
    //   const userinfo = JSON.parse(getCookie('ZJYUSERINFO'))
    //   this.phone = userinfo.passwordMobile
    //   let result = await new Promise((resolve, reject) => {
    //     LoginService.isDoubleVerify(userinfo.passwordMobile).then(res => {
    //       if (res.code === 200){
    //         if (res.data){ // 需要二次验证-弹出弹框
    //           console.log('未二次验证！')
    //           this.showVerify = true
    //           resolve(true)
    //         } else { // 已经验证过
    //           console.log('二次验证已通过！')
    //           resolve(false)
    //         }
    //       } else {
    //         this.$message.error(res.msg)
    //       }
    //     })
    //   })
    //   return result
    // },

    // 二次验证---确定
    verifyConfirm (){
      console.log('验证成功，请继续操作！')
    },
    // 1.4.1 删除成员
    async deleteOption (record) {
      // let flag = await this.isDoubleVerify()
      // if (flag) {
      //   return false
      // }
      this.sentLog(100112045)
      this.$confirm({
        message: '确定删除该成员吗？',
        submit: () => {
          this.deleteProjectMember(record)
        }
      })
    },
    // 1.4 删除成员-确定
    deleteProjectMember (item) {
      let url = zjycloud + '/#/project/joined/list'
      this.loading = true
      r2Project
        .removeMembers(this.MemberInfo.projectId, item.memberId, encodeURIComponent(url))
        .then(ret => {
          this.loading = false
          if (+ret.code === 200) {
            this.init()
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.addOperationRecords(14, item.account, {page: 'detailMember', action: 'deleteMember'})
          } else if (+ret.code === 240015 || +ret.code === 403){
            this.$message({
              type: 'error',
              message: '无访问权限！'
            })
          } else {
            this.$message({
              type: 'error',
              message: '失败了，请稍后重试！'
            })
          }
        }).catch(() => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '失败了，请稍后重试！'
          })
        })
      // if (role !== '总负责人') {
      //   if (+this.prjRole === 1) {
      //     role = '项目管理者'
      //   } else {
      //     role = '项目编辑者'
      //   }
      // }
    },
    // 1.5 关闭添加员工
    closeMemberShow () {
      this.show = false
      this.MemberInfo.MemberShow = false
    },
    // 1.6 添加员工
    addMemberClick () {
      this.show = true
      this.MemberInfo.MemberShow = true
      this.sentLog(100112042)
    },
    // 1.7 备案库-更改权限
    privilegeClick (item, newRole, oldRole) {
      if (newRole === 1 && oldRole !== 3) {
        return
      }
      if (newRole === 2 && oldRole === 3) {
        return
      }
      let params = [{
        memberId: item.memberId,
        visible: newRole === 1
      }]
      this.loading = true
      r2Project.setRecordedMembersPrivilege(params, {id: this.MemberInfo.projectId}).then(data => {
        this.loading = false
        if (+data.code === 200) {
          this.init()
          this.$message.success('权限设置成功！')
        } else {
          this.$message.error('权限设置失败！')
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('权限设置失败！')
      })
    }
  },
  filters: {
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd')
    },
    privilegeFilter: function (item) {
      if (item.roleId !== 3) {
        return '可见'
      } else {
        return '不可见'
      }
    },
    roleFilter: function (item) {
      if (item.roleId === 1) {
        return '项目负责人'
      } else if (item.userRole === 2) {
        return '项目库管理员'
      } else if (item.roleId === 2) {
        return '项目成员'
      } else {
        return ''
      }
    }
  },
  mounted () {
    this.init()
  },
  updated () {
    let scrollY
    try {
      scrollY = this.$refs.containerWrapper.clientHeight > this.$refs.bodyWrapper.clientHeight
    } catch (e) {
      scrollY = false
    }
    this.scrollY = scrollY
  },
  created () {
    console.log('*************prjRole*********', this.prjRole)
    this.isAdmin = this.hasModuleAuth('zjy_module_project_zsxmk_wcyd_manage') || this.hasModuleAuth('zjy_module_project_zsxmk_qbxm_manage')
    let userinfo = getCookie('ZJYUSERINFO')
    // switch (+getCookie('role')) {
    //   case 1:
    //     role = '管理员'
    //     break
    //   case 2:
    //     role = '总负责人'
    //     break
    //   case 3:
    //     role = '档案室负责人'
    //     break
    //   case 4:
    //     role = '普通员工'
    //     break
    //   default:
    //     role = '管理员'
    //     break
    // }
    if (userinfo) {
      userinfo = JSON.parse(userinfo)
      this.user = userinfo
    }
  }
}
</script>
